import request from '@/utils/request'

const logisticsApi = {
  trade_logistics_list: '/trade/logistics/',
  trade_logistics_create: '/trade/logistics/',
  trade_logistics_update: '/trade/logistics/',
  trade_logistics_delete: '/trade/logistics/',
  trade_logistics_archived: '/trade/logistics_archived/',
  trade_logistics_attachment: '/trade/logistics_attachment/'
}

/**
 * 列表
 */
export function logistics_list (parameter) {
  return request({
    url: logisticsApi.trade_logistics_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function logistics_create (parameter) {
  return request({
    url: logisticsApi.trade_logistics_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function logistics_update (parameter, logistics_id) {
  return request({
    url: logisticsApi.trade_logistics_update + logistics_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function logistics_delete (logistics_id) {
  return request({
    url: logisticsApi.trade_logistics_delete + logistics_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function logistics_archived (parameter) {
  return request({
    url: logisticsApi.trade_logistics_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 担保合同附件列表
 * @param parameter
 * @returns {AxiosPromise}
 */
export function logistics_attachment_list (parameter) {
  return request({
    url: logisticsApi.trade_logistics_attachment,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 担保合同附件添加
 */
export function logistics_attachment_create (parameter) {
  return request({
    url: logisticsApi.trade_logistics_attachment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 担保合同附件删除
 */
export function logistics_attachment_delete (contract_attachment_id) {
  return request({
    url: logisticsApi.trade_logistics_attachment + contract_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
